import Button from '@components/Button';
import { Card, CardContent, Grid, Stack } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useSaveJobOfferTemplate } from '../hooks/useSaveJobOfferTemplate';
import JobOfferTemplateProfileForm from './JobOfferTemplateProfileForm';
import CandidateForm from '@modules/JobOffers/forms/CandidateForm';
import ContractForm from '@modules/JobOffers/forms/ContractForm';
import DescriptionForm from '@modules/JobOffers/forms/DescriptionForm';
import PositionForm from '@modules/JobOffers/forms/PositionForm';
import RecruitmentForm from '@modules/JobOffers/forms/RecruitmentForm';
import PreLoader from '@components/PreLoader';
import { useQuery } from '@apollo/client';
import { GET_PRO } from '@gql/pros';
import Text from '@components/Text';
import { FlexRow } from '@components/FlexRow';

interface JobOfferTemplateFormProps {
    proId?: string;
    template?: any;
    onSuccess?: (values: any) => void;
    onError?: (error: any) => void;
    cancelDisabled?: boolean;
}

const JobOfferTemplateForm = (props: JobOfferTemplateFormProps) => {
    const navigate = useNavigate();

    const { data: proData, loading: fetchingPro } = useQuery(GET_PRO, {
        variables: { proId: props.proId },
        skip: !props.proId,
    });

    const pro = proData?.getPro;

    const { submit, loading: saveLoading, success, data, methods } = useSaveJobOfferTemplate({
        proId: props.proId,
        template: props?.template,
        onSuccess: (result) => {
            props.onSuccess?.(result);
        },
        onError: (error) => {
            props.onError?.(error);
        },
    });

    const { handleSubmit } = methods;

    return (
        <FormProvider {...methods}>
            <div style={{ flex: 1 }}>
                {fetchingPro && <PreLoader />}
                {!success ? (
                    <Stack gap={3}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <CardContent>
                                        <PositionForm pro={pro} />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <CardContent>
                                        <JobOfferTemplateProfileForm pro={pro} />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <CardContent>
                                        <CandidateForm />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <CardContent>
                                        <ContractForm />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <CardContent>
                                        <DescriptionForm />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <CardContent>
                                        <RecruitmentForm pro={pro} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <FlexRow justifyContent="flex-end" style={{ marginTop: 16 }}>
                            <Button
                                loading={saveLoading}
                                onClick={() => handleSubmit(submit)()}
                            >
                                Enregistrer le modèle
                            </Button>
                        </FlexRow>
                    </Stack>
                ) : (
                    <Stack style={{ paddingTop: 24, gap: 24, justifyContent: 'center', alignItems: 'center' }}>
                        <Stack style={{ gap: 8, maxWidth: 595 }}>
                            <Text heading dark bold size={24} style={{ textAlign: 'center' }}>
                                Modèle {props?.template?._id ? 'modifié' : 'créé'} avec succès
                            </Text>
                            <Text darkGray size={16} style={{ textAlign: 'center' }}>
                                Votre modèle d'offre d'emploi a été {props?.template?._id ? 'modifié' : 'créé'} avec succès.
                            </Text>
                        </Stack>
                        <FlexRow style={{ gap: 12, justifyContent: 'center' }}>
                            {data?.jobNumber && (
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate(`/job-offer-templates/${data.jobNumber}/detail`)}
                                >
                                    Voir le modèle
                                </Button>
                            )}
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => navigate('/job-offer-templates')}
                            >
                                Retour à la liste
                            </Button>
                        </FlexRow>
                    </Stack>
                )}
            </div>
        </FormProvider>
    );
};

export default JobOfferTemplateForm;
